import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";

type BootstrapData = {
	locale?: string;
};

const bootstrapData = (
	window as unknown as { __BOOTSTRAP_DATA__?: BootstrapData }
).__BOOTSTRAP_DATA__;

i18next.use(initReactI18next).init({
	resources: { en: { translation: en } },
	lng: bootstrapData?.locale || "en",
	fallbackLng: "en",
	interpolation: { escapeValue: false },
	initAsync: false,
});

export default i18next;
